import { Box, TableActionTypes, TableState } from 'web-library';
import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import {
  PostReviewGroupExamRegistrationRequest,
  PostReviewGroupExamRegistrationResponse,
  RegistrationRequestTab,
} from '../../../api-refactored/group-exam-registration/usePostReviewGroupExamRegistration';
import CandidateListTab from './CandidateListTab';
import SubjectListTab from './SubjectListTab';
import { UseCustomMutationReturn } from '../../../api-refactored/utils/useCustomMutation';
import { GenericErrorResponse } from '../../../api-refactored/typings';
import CandidateSubjectListTabPanels from './CandidateSubjectListTabPanels';
import { ComponentUsage } from './model';
import {
  PostGroupExamRegistrationSummaryRequest,
  PostGroupExamRegistrationSummaryResponse,
} from '../../../api-refactored/group-exam-registration/usePostGroupExamRegistrationSummary';

import {typeTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  root: {
    '& #library-data-table-filter-dialog': {
      backgroundColor: 'red',
      '& .MuiButtonBase-root.MuiButton-root': {
        marginTop: theme.spacing(2),
      },
    },
  },
  actionButtonSmall: {
    textAlign: 'right',
    '& .MuiButton-root': {
      padding: 0,
      height: 0,
      '& .MuiButton-label': {
         ...typeTheme(theme, 'buttonSmall'),
      },
    },
  },
  actionButtonMedium: {
    textAlign: 'right',
    '& .MuiButton-root': {
      padding: 0,
      height: 0,
      '& .MuiButton-label': {
         ...typeTheme(theme, 'buttonMedium'),
      },
    },
  },
  actionButtonSmallLeft: {
    textAlign: 'left',
    '& .MuiButton-root': {
      padding: 0,
      height: 0,
      '& .MuiButton-label': {
         ...typeTheme(theme, 'buttonSmall'),
      },
    },
  },
  actionButtonMediumLeft: {
    textAlign: 'left',
    '& .MuiButton-root': {
      padding: 0,
      height: 0,
      '& .MuiButton-label': {
         ...typeTheme(theme, 'buttonMedium'),
      },
    },
  },
  sendEmailButton: {
    color: theme.color.link.linkDefault01,
    whiteSpace: 'nowrap',
    padding: 0,
    minWidth: 0,
    height: 0,
    '& p': {
       ...typeTheme(theme, 'buttonMedium'),
    },
  },
  dropdownSelect: {
    marginBottom: theme.spacing(3),
  },
  noPaddingButton: {
    padding: `0 !important`,
  },
}));

interface ICandidateSubjectListTabs {
  tabStateHandler: {
    selectedTab: number;
    setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
  };

  applicationUuid: string;
  getCandidateOrSubjectType: RegistrationRequestTab;
  candidateDataTableHandler: {
    candidateTabTableState: TableState;
    candidateTabTableDispatch: React.Dispatch<TableActionTypes>;
  };
  /** If Review will return first type of useMutationHook,
   * Summary will return second type
   * */
  useMutationHook:
  | UseCustomMutationReturn<
    PostReviewGroupExamRegistrationResponse,
    AxiosError<GenericErrorResponse>,
    PostReviewGroupExamRegistrationRequest,
    unknown
  >
  | UseCustomMutationReturn<
    PostGroupExamRegistrationSummaryResponse,
    AxiosError<GenericErrorResponse>,
    PostGroupExamRegistrationSummaryRequest,
    unknown
  >;
  componentUsageFor: ComponentUsage;
  totalFee?: string;
}

const CandidateSubjectListTabs = ({
  tabStateHandler,
  applicationUuid,
  getCandidateOrSubjectType,
  candidateDataTableHandler,
  useMutationHook,
  componentUsageFor,
  totalFee = '',
}: ICandidateSubjectListTabs) => {
  const { selectedTab, setSelectedTab } = tabStateHandler;
  const { t } = useTranslation();

  const { classes } = useStyles();

  const { data } = useMutationHook;
  return (
    <Box className={classes.root}>
      <CandidateSubjectListTabPanels tabStateHandler={{ selectedTab, setSelectedTab }} t={t} />
      {selectedTab === 0 && data?.candidateList && (
        <Box id="candidate-listing">
          <CandidateListTab
            candidateDataTableHandler={candidateDataTableHandler}
            classes={classes}
            t={t}
            componentUsageFor={componentUsageFor}
            applicationUuid={applicationUuid}
            totalFee={totalFee}
          />
        </Box>
      )}
      {selectedTab === 1 && (
        <Box id="subject-listing">
          <SubjectListTab
            getCandidateOrSubjectType={getCandidateOrSubjectType}
            classes={classes}
            componentUsageFor={componentUsageFor}
            applicationUuid={applicationUuid}
            t={t}
          />
        </Box>
      )}
    </Box>
  );
};

export default CandidateSubjectListTabs;
